import { styles } from '../../../utilities'
import type { Tokens } from '../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      wrap: {
        alignItems: 'center',
        display: 'inline-flex',
      },

      progress: {
        ...styles.visuallyHidden,
      },

      circleFill: {
        fill: 'transparent',
        transform: 'rotate(-90deg)',
        transformOrigin: '50% 50%',
      },

      circleTrack: {
        fill: 'transparent',
      },

      text: {
        ...tokens.fontLabel,
      },
    },

    hidden: styles.visuallyHidden,
  } as const
}
